<template>
  <div class="pg-tabs" :class="{ 'pg-tabs--card': type === 'card' }">
    <div class="pg-tabs__header" v-if="!hideHeader">
      <div class="pg-tabs__header-nav">
        <div class="pg-tabs__header-nav-bar" :style="barStyle"></div>
        <div
          ref="navItemRef"
          class="pg-tabs__header-nav-item"
          :class="{ active: value === tab.name }"
          v-for="tab in tabsList"
          :key="tab.name"
          @click="(event) => activeChange(event, tab.name)"
        >
          <Popover popper-class="pg-tabs__popper" :value="!!labelTips?.[tab.name]" trigger="manual">
            <span class="pg-tabs__popper-text" v-if="!!labelTips?.[tab.name]">{{
              labelTips[tab.name]
            }}</span>
            <template #reference>
              <span>{{ tab.label }}</span>
            </template>
          </Popover>
        </div>
      </div>
    </div>
    <div class="pg-tabs__content">
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { useSlots, onMounted, onUpdated, shallowRef, ref, provide, toRef, nextTick } from 'vue'
import { Popover } from 'element-ui'

const props = defineProps({
  value: String,
  hideHeader: Boolean,
  labelTips: Object,
  type: String,
})
const emit = defineEmits(['tab-click', 'input'])

const slots = useSlots()

const navItemRef = ref(null)

//获取插槽中的PgTabPane
const getTabPane = (slotsList) => {
  const childSlots = slotsList.filter(
    (im) => im.componentOptions?.Ctor?.options?.name === 'PgTabPane'
  )
  if (childSlots.length === 0 && slotsList.length > 0) {
    return getTabPane(slotsList[0].componentInstance.children)
  } else {
    return childSlots
  }
}
const tabsList = shallowRef([])
const getTabs = () => {
  const tabPaneSlot = getTabPane(slots.default())
  const tabsInstance = tabPaneSlot.map((im) => im.componentInstance)
  const changed = !(
    tabsList.value.length === tabsInstance.length &&
    tabsInstance.every((im, index) => im === tabsList.value[index])
  )
  if (changed) {
    tabsList.value = tabPaneSlot.map((im) => im.componentInstance)
    nextTick(() => {
      if (props.value) {
        const activeRef = navItemRef.value?.find((im) => im.className.indexOf('active'))
        activeRef && activeChange({ currentTarget: activeRef }, props.value)
      }
    })
  }
}

onMounted(getTabs)
onUpdated(getTabs)

const barStyle = ref({})
const activeChange = (event, name) => {
  const elStyle = window.getComputedStyle(event.currentTarget)
  const tabPaneEl = []
  const parentEl = event.currentTarget.parentElement.children
  for (let i = 0; i < parentEl.length; i++) {
    if (parentEl[i] === event.currentTarget) {
      break
    }
    if (parentEl[i].className.indexOf('pg-tabs__header-nav-bar') === -1) {
      tabPaneEl.push(parentEl[i])
    }
  }
  const translateX = tabPaneEl.reduce((pre, cur) => {
    pre += cur.clientWidth
    return pre
  }, 0)
  barStyle.value = {
    width: `${
      event.currentTarget.clientWidth -
      parseFloat(elStyle.paddingLeft) -
      parseFloat(elStyle.paddingRight)
    }px`,
    transform: `translateX(${translateX + parseFloat(elStyle.paddingLeft)}px)`,
  }
  emit('input', name)
  emit('tab-click', name)
}

const INJECTKEY = 'PGTABS_INJECT_KEY'
provide(INJECTKEY, toRef(props, 'value'))
</script>
<style lang="scss">
@import '../style/tabs.scss';
</style>
